import React, { useState, useEffect, useRef } from 'react'

import Checkbox from '../../checkbox'

import * as S from '../styles'

import IProps from './props'
import IAvailability from '../../../../interfaces/availability'

import TranslationHelper from '../../../../helpers/helper-translation'
import { useClickOutside } from '../utils'

const weekDays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

const schedules = ['morning', 'afternoon', 'night']

const AvailabilityPopup = ({
  onApply,
  onClose,
  selectedAvailability,
}: IProps) => {
  const [selectedFields, setSelectedFields] = useState<IAvailability>({})

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setSelectedFields(selectedAvailability)
  }, [selectedAvailability])

  const handleCheckDay = (day: string) => {
    setSelectedFields((prevSelectedFields) => {
      const updatedFields = { ...prevSelectedFields }

      updatedFields[day] = { selected: !prevSelectedFields[day]?.selected }

      if (updatedFields[day]?.selected) {
        schedules.forEach((schedule) => {
          if (!updatedFields[day][schedule]) {
            updatedFields[day][schedule] = false
          }
        })
      }

      if (!updatedFields[day]?.selected) {
        schedules.forEach((schedule) => {
          updatedFields[day][schedule] = false
        })
      }

      return updatedFields
    })
  }

  const handleCheckField = (day: string, schedule: string) => {
    setSelectedFields((prevSelectedFields) => ({
      ...prevSelectedFields,
      [day]: {
        ...prevSelectedFields[day],
        [schedule]: !prevSelectedFields[day]?.[schedule],
      },
    }))
  }

  const handleApply = () => {
    onApply(selectedFields)
    onClose()
  }

  useClickOutside(
    containerRef,
    'availability',
    'availabilities',
    () => {
      onApply(selectedFields)
    },
    handleApply,
  )

  return (
    <S.Container ref={containerRef} className="availabilities-popup">
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
      {weekDays.map((day) => (
        <S.CheckboxContainer key={day}>
          <Checkbox
            id={day}
            label={TranslationHelper.translateDay(day)}
            checked={selectedFields[day]?.selected || false}
            onCheck={() => handleCheckDay(day)}
          />
          {selectedFields[day]?.selected && (
            <S.Schedules>
              {schedules.map((schedule) => (
                <Checkbox
                  key={`${day}-${schedule}`}
                  id={`${day}-${schedule}`}
                  label={TranslationHelper.translateSchedule(schedule)}
                  checked={selectedFields[day]?.[schedule] || false}
                  onCheck={() => handleCheckField(day, schedule)}
                />
              ))}
            </S.Schedules>
          )}
        </S.CheckboxContainer>
      ))}
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
    </S.Container>
  )
}

export default AvailabilityPopup
